<template>
  <div class="btn-group" v-on-clickaway="closeBox">
    <a href="javascript:;" v-on:click="toggleBox" data-toggle="dropdown">
      <i class="fa fa-filter" :class="{ 'text-muted': !keywordIsSet, 'activeOption': keywordIsSet}"></i>
    </a>
    <ul v-if="title === 'Medikamente'" class="dropdown-menu" style="padding: 5px; min-width: 280px;" v-bind:style="{ display: (boxes[field]) ? 'block' : 'none' }">
      <medical-filter :boxes="boxes" v-bind="$props" />
    </ul>
    <ul v-else-if="filterType === 'Boolean'" class="dropdown-menu" style="padding: 3px">
      <bool-filter v-bind="$props" />
    </ul>
    <ul v-else-if="filterType.includes('Date')" class="dropdown-menu" style="padding: 3px; min-width: 210px;" v-bind:style="{ display: (boxes[field]) ? 'block' : 'none' }">
      <date-filter v-bind="$props" />
    </ul>
    <ul v-else-if="filterType.includes('Number')" class="dropdown-menu" style="padding: 3px">
      <number-filter v-bind="$props" />
    </ul>
    <ul v-else-if="filterType === 'Array'" class="dropdown-menu" style="padding: 3px; min-width: 280px;" v-bind:style="{ display: (boxes[field]) ? 'block' : 'none' }">
      <category-filter :boxes="boxes" v-bind="$props" />
    </ul>
    <ul v-else class="dropdown-menu" style="padding: 3px">
      <text-filter v-bind="$props" />
    </ul>
  </div>
</template>
<script>
import filterMixins from './filter-mixins'
import textFilter from './textFilter'
import categoryFilter from './CategoryFilter'
import boolFilter from './booleanFilter'
import medicalFilter from './medicalFilter'
import dateFilter from './dateFilter'
import numberFilter from './numberFilter'
import { mixin as clickaway } from 'vue-clickaway'

export default {
  mixins: [filterMixins, clickaway],
  props: {
    field: String,
    title: String,
    query: Object,
    items: { type: Array, default: () => [] },
    resetKeyword: Boolean,
    nChanges: Number,
    filterType: { type: String, default: () => 'FreeText' }
  },
  components: {
    'text-filter': textFilter,
    'category-filter': categoryFilter,
    'bool-filter': boolFilter,
    'medical-filter': medicalFilter,
    'date-filter': dateFilter,
    'number-filter': numberFilter
  },
  data () {
    return {
      boxes: {}
    }
  },
  methods: {
    toggleBox () {
      this.$set(this.boxes, this.field, !this.boxes[this.field])
    },
    closeBox () {
      this.$set(this.boxes, this.field, false)
    },
    setOptions () {} // to avoid error message
  }
}
</script>
<style>
.dropdown-is-open {
  display: block !important;
}
input[type=search]::-webkit-search-cancel-button {
  -webkit-appearance: searchfield-cancel-button;
  cursor: pointer;
}
.search-box {
  z-index: 1;
}
.medication-group {
  margin-bottom: 5px;
}
.open>.dropdown-menu {
  display: block;
  opacity: 1;
  visibility: visible;
  width: 210px;
}
.search-input-field {
  cursor: text;
  height: 30px !important;
}
.search-button {
  height: 30px;
  width: 37px;
  padding-left: 10px;
  padding-top: 0px;
  padding-right: 10px;
  padding-bottom: 5px;
}

.autocomplete {
    position: relative;
    width: 130px;
}

.autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid black;
    /*height: 120px;*/
    overflow: auto;
}

.autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
    background-color: gainsboro;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
    background-color: #4AAE9B;
    color: white;
}

</style>



// WEBPACK FOOTER //
// src/components/plugins/th-Filter.vue